import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-offset-dialog',
  templateUrl: './offset-dialog.component.html',
  styleUrls: ['./offset-dialog.component.scss']
})
export class OffsetDialogComponent {

  @ViewChild("offsetField") offsetField;

  anchor: string;
  before: boolean = false;
  defaultAnchor: string = '00:00:00:00';
  defaultOffset: string = '00:00:00:00';
  offset: string;
  subtract: boolean = false;

  get valid(): boolean { return this.offsetField.valid }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<OffsetDialogComponent>) { }

  onSignChange(event) {
    this.subtract = event.value != null ? event.value.stored == "subtract" : false;
  }

  onOffsetChange(event) {
    this.offset = event.value;
  }

  onBeforeChange(event) {
    this.before = event.value != null ? event.value.stored == "before" : false;
  }

  onAnchorChange(event) {
    this.anchor = event.value;
  }

  onClose() {
    if (this.offset == null) { return null }
    return {
      anchor: this.anchor,
      before: this.before,
      offset: this.offset,
      subtract: this.subtract
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/forms/offset-dialog.component.ts